export function JsonBlock({ value, show }: { value: unknown; show: boolean }) {
  if (!show) {
    return null;
  }

  return (
    <pre className="overflow-x-auto rounded-md bg-platform-primary/5 p-3 text-spark-text-primary text-xs">
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}
